// extracted by mini-css-extract-plugin
export default {"container":"tH-z","header":"uH-z","details":"vH-z","link":"wH-z"};